import { render } from "./SummaryAndConfirmation.vue?vue&type=template&id=345920a6&scoped=true&bindings={\"terms\":\"data\",\"enquirySourceID\":\"data\",\"customerHasEnquirySource\":\"options\",\"hasInvalidFields\":\"options\",\"bookedHireItems\":\"options\",\"holidayTotal\":\"options\",\"uk2ISO\":\"options\",\"ISO2Uk\":\"options\",\"continueToPayment\":\"options\",\"enqSourceChanged\":\"options\",\"saveToDatabase\":\"options\"}"
import script from "./SummaryAndConfirmation.vue?vue&type=script&lang=js"
export * from "./SummaryAndConfirmation.vue?vue&type=script&lang=js"

import "./SummaryAndConfirmation.vue?vue&type=style&index=0&id=345920a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-345920a6"

export default script